import { UserRole } from '../types/auth';

export const isExecutive = (role: UserRole): boolean => {
  return role === 'CEO' || role === 'CFO';
};

export const hasExecutiveAccess = (userRole: UserRole, requiredRole: UserRole | UserRole[]): boolean => {
  const roles = Array.isArray(requiredRole) ? requiredRole : [requiredRole];
  
  // If CEO access is required, allow both CEO and CFO
  if (roles.includes('CEO')) {
    return isExecutive(userRole);
  }
  
  return roles.includes(userRole);
};

export const canUseExcelUpload = (userRole: UserRole, department?: Department): boolean => {
  // Allow Excel upload for AR/AP departments for all employees in those departments
  if (department === 'ACCOUNTS_RECEIVABLE' || department === 'ACCOUNTS_PAYABLE') {
    return true; // Allow all employees in AR/AP departments
  }
  return false;
};
export const validatePassword = (password: string): string[] => {
  const errors: string[] = [];
  if (password.length < 8) {
    errors.push('Password must be at least 8 characters long');
  }
  if (!/[A-Z]/.test(password)) {
    errors.push('Password must contain at least one uppercase letter');
  }
  if (!/[a-z]/.test(password)) {
    errors.push('Password must contain at least one lowercase letter');
  }
  if (!/[0-9]/.test(password)) {
    errors.push('Password must contain at least one number');
  }
  return errors;
};